/**
 * @returns {boolean}
 */
function isIe () {
  return navigator.userAgent.includes('MSIE') || navigator.appVersion.includes('Trident/')
}

module.exports = { isIe }
